import * as React from 'react';
import { useState, useCallback } from 'react';

import { PaginatedItemOverview, ShareButton } from 'components/common';
import SectionComponent from 'components/common/Section/SectionComponent';
import UsersQueryHelper from 'components/users/UsersQueryHelper';
import EntityShareModal from 'components/permissions/EntityShareModal';

import UserItemComponent from './UsersSection/UserItemComponent';

import TeamsDomain from '../../domainActions/TeamsDomain';
import type Team from '../../logic/Team';

type Props = {
  team: Team;
};

const UsersSection = ({ team: { id, name } }: Props) => {
  const [showShareModal, setShowShareModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const usersQueryHelper = <UsersQueryHelper />;

  const _onLoad = useCallback(
    (pagination) => {
      setLoading(true);

      return TeamsDomain.loadUsersForTeam(id, name, pagination).then((paginatedUsers) => {
        setLoading(false);

        return paginatedUsers;
      });
    },
    [id, name],
  );

  return (
    <SectionComponent
      title="Users"
      showLoading={loading}
      headerActions={<ShareButton entityId={id} entityType="team_users" onClick={() => setShowShareModal(true)} />}>
      <PaginatedItemOverview
        noDataText="No selected users have been found."
        onLoad={_onLoad}
        queryHelper={usersQueryHelper}
        overrideItemComponent={UserItemComponent}
      />
      {showShareModal && (
        <EntityShareModal
          entityId={id}
          entityType="team_users"
          entityTypeTitle="Team Members"
          entityTitle={name}
          description="Search for a User or Team to add as collaborator on this team's members."
          onClose={() => setShowShareModal(false)}
        />
      )}
    </SectionComponent>
  );
};

export default UsersSection;
